import React from "react";
import { useHistory } from "react-router-dom";
import "./trix.scss";
import { usePostTags } from "../hooks";
import { Tag } from ".";

export default function Tags() {
  const { getNewTagFromUser, addNewTag, refreshTags, deleteTag, tags } =
    usePostTags();
  const history = useHistory();
  return (
    <div>
      <h1>Your HUBtags</h1>
      <button
        onClick={async () => {
          const nextTag = await getNewTagFromUser({ value: "NEW" });
          if (nextTag) {
            await addNewTag({ tagName: nextTag });
            refreshTags();
          }
        }}
      >
        Add a HUBtag
      </button>
      {tags && tags.length > 0 && <p>Click a tag to edit it</p>}
      <hr />
      <p className="flex">
        {tags.map((tag) => (
          <Tag
            key={tag.name}
            onClick={() => history.push(`/tags/${tag._id}`)}
            tag={tag}
            deleteTag={deleteTag}
            showDelete={true}
          />
        ))}
      </p>
    </div>
  );
}
